import React from "react";

export const PageTabsContext = React.createContext<
  | {
      setTabCount: (tabKey: string, count: number | undefined) => void;
      isPageTabs: boolean;
    }
  | undefined
>(undefined);
